function AuditEventsController(
  notificationService,
  eventsExportService,
  userService,
  CommonService,
  userViewService,
  arraySortService,
  $translate,
  $interval,
  $timeout,
  $uibModal,
  __env,
  $scope
) {
  const ctrl = this;
  const env = __env;

  ctrl.$onInit = () => {
    ctrl.currentView = userViewService.getView();
    ctrl.consist = CommonService.getConsist();
    ctrl.contentAreaId = 'div#auditScrollContainer';
    ctrl.area = '#gridletContentArea-audit-events-gridlet';
    ctrl.sortType = 'ACTIVATED';
    ctrl.sortReverse = true;
    ctrl.dataLoading = false;
    ctrl.smallFont = false;
    ctrl.loadBusy = false;
    ctrl.hasConsist = env.profile === 'LU';
    ctrl.events = [];
    ctrl.accordionStatus = null;
    ctrl.customLayout = env.profile === 'MELCO';
    ctrl.hasAuditEventsRead = userService.hasAuditEventsRead();
    $scope.$emit('gridlet-register-export', {
      excel: () => ctrl.exportTo('excel'),
      csv: () => ctrl.exportTo('csv'),
      isExporting: () => ctrl.fetching,
    });
    if (ctrl.hasAuditEventsRead) {
      ctrl.loadEvents();
      startPoll();
    }
    ctrl.initialized = true;
  };

  ctrl.$onChanges = changes => {
    if (changes.settings && ctrl.initialized) {
      $timeout(() => {
        adjustContentSize(ctrl.area, ctrl.contentAreaId);
        ctrl.loadEventsPage();
      }, 200);
    }
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.dataFetchPromise);
  };

  const adjustContentSize = (selectorId, contentAreaSelectorId) => {
    $timeout(function () {
      ctrl.areaWidth = $(contentAreaSelectorId).width();
      // If adjust is fired when resize event is going on, size is incorrectly set to 100
      if (ctrl.areaWidth === 100) {
        ctrl.smallFont = false;
      } else {
        ctrl.smallFont = ctrl.areaWidth < 580;
      }
    }, 200);
  };
  
  // Triggered with 500ms debounce each time
  // user types something in search filter field
  ctrl.searchChange = () => {
    if (ctrl.hasAuditEventsRead) {
      ctrl.events = [];
      ctrl.loadEvents();
    }
  };
  
  ctrl.setSortType = column => {
    if (ctrl.loadBusy) return;
    ctrl.sortReverse = (ctrl.sortType === column) ? !ctrl.sortReverse : false;
    ctrl.sortType = column;
    ctrl.events = [];
    ctrl.loadEvents();
  };

  const startPoll = () => {
    if (!ctrl.dataFetchPromise) {
      ctrl.lastLoad = DateTime.now();
      ctrl.dataFetchPromise = $interval(triggerFetchLoad, 10000);
    }
  };

  const triggerFetchLoad = () => {
    if (ctrl.lastLoad.diffNow('seconds').seconds < -9) {
      ctrl.loadEvents();
    }
  };

  ctrl.openEvent = eventItem => {
    const modalInstance = $uibModal.open({
      templateUrl: '/modules/modals/notification-module.html',
      controller: 'notificationModalController',
      windowClass: 'medium-size-modal',
      resolve: {
        notificationItem: function () {
          return eventItem;
        },
        consist: function () {
          return eventItem.displayableTrainId ? eventItem.displayableTrainId : eventItem.consist;
        },
        listType: function () {
          return 'audit';
        }
      },
    });
    modalInstance.result.then(
      reload => {
        if (reload) {
          ctrl.loadEvents();
        }
      },
      () => { }
    );
  };

  // Fetch list of audit events, returns data if no error.
  // fetchEvents :: (Object) -> [Object]
  ctrl.fetchEvents = async params => {
    try {
      const data = await notificationService.getAuditEvents(params);
      return this.handleEventData(data);
    } catch (e) {
      console.error(`Event fetch error: ${e}`);
      return e;
    }
  };

  ctrl.handleEventData = data => {
    // If MELCO, convert eventIds to hex and assign status values
    if (ctrl.customLayout) {
      for (const eventItem of data) {
        eventItem.eventId = eventItem.eventHexCode;
        eventItem.status = eventItem.action;
      }
    }
    return data;
  };

  ctrl.loadEvents = async () => {
    let el = document.querySelector('#auditScrollContainer');
    if (ctrl.loadBusy || el.scrollTop > 50) return;
    ctrl.loadBusy = true;
    let params = {
      count: ctrl.settings.fullscreen ? 100 : 25,
      skip: 0,
      eventSortType: ctrl.sortType,
      sortReverse: ctrl.sortReverse
    };
    if (ctrl.searchTerm) {
      params.searchString = ctrl.searchTerm;
    }

    const data = await ctrl.fetchEvents(params);
    if (data && !angular.equals(ctrl.events, data)) {
      addEvents(data);
    }
    
    adjustContentSize(ctrl.area, ctrl.contentAreaId);
    ctrl.dataLoading = false;
    ctrl.loadBusy = false;
  };

  function isSameEvent(event1, event2) {
    return event1.id === event2.id &&
        event1.consist === event2.consist &&
        event1.eventId === event2.eventId &&
        event1.carNumber === event2.carNumber &&
        event1.activated === event2.activated &&
        event1.title === event2.title &&
        event1.action === event2.action &&
        event1.priority === event2.priority &&
        event1.qualifier === event2.qualifier;
  }

  function addEvents(data) {
    data.forEach(item => {
      const alreadyIncluded = Boolean(ctrl.events.find(event => isSameEvent(event, item)));
      if (!alreadyIncluded) {
        ctrl.events.push(item);
      }
    });
    sortEvents();
  }

  const sortEvents = () => {
    switch(ctrl.sortType) {
      case "CONSIST": {
        arraySortService.sortArrayWithKey(ctrl.events,  'consist', ctrl.sortReverse);
        break;
      }
      case "CAR": {
        arraySortService.sortArrayWithKey(ctrl.events,  'carNumber', ctrl.sortReverse);
        break;
      }
      case "PRIORITY": {
        const valueMap = {"Red": 0, "Yellow": 1, "White": 2, null: 3};
        arraySortService.sortArrayWithMappedValues(ctrl.events, 'priority', ctrl.sortReverse, valueMap);
        break;
      }
      case "EVENT_ID": {
        arraySortService.sortArrayWithKey(ctrl.events, 'eventId', ctrl.sortReverse);
        break;
      }
      case "EVENT_TYPE": {
        arraySortService.sortArrayWithKey(ctrl.events, 'status', ctrl.sortReverse);
        break;
      }
      case "ACTIVATED": {
        arraySortService.sortArrayWithKey(ctrl.events, 'activated', ctrl.sortReverse);
        break;
      }
      case "TITLE": {
        arraySortService.sortArrayWithKey(ctrl.events, 'title', ctrl.sortReverse);
        break;
      }
      case "ACTION": {
        arraySortService.sortArrayWithKey(ctrl.events,  'action', ctrl.sortReverse);
        break;
      }
      default: {
        console.log("Invalid sort choice", ctrl.sortType);
        break;
      }
    }
  };

  ctrl.loadEventsPage = async () => {
    ctrl.currentScrollPos = document.querySelector('#auditEventsGridletContainer').scrollTop;
    if (ctrl.loadBusy || ctrl.oldScrollPos === ctrl.currentScrollPos) return;
    ctrl.loadBusy = true;
    const params = {
      count: ctrl.settings.fullscreen ? 100 : 25,
      skip: ctrl.events.length || 0,
      eventSortType: ctrl.sortType,
      sortReverse: ctrl.sortReverse,
    };
    if (ctrl.searchTerm) {
      params.searchString = ctrl.searchTerm;
    }
    let data = null;
    data = await ctrl.fetchEvents(params);
    
    addEvents(data);
    adjustContentSize(ctrl.area, ctrl.contentAreaId);
    ctrl.loadBusy = false;
    ctrl.oldScrollPos = angular.copy(ctrl.currentScrollPos);
  };

  ctrl.exportTo = async (fileType) => {
    let criteria = {};
    criteria.skip = 0;
    criteria.count = 50000;
    criteria.localTimezone = DateTime.local().zoneName;
    criteria.sortReverse = ctrl.sortReverse;
    if (ctrl.sortType) {
      criteria.eventSortType = ctrl.sortType;
    } 
    if (ctrl.searchTerm) {
      criteria.searchString = ctrl.searchTerm;
    }
    ctrl.fetching = true;

    if (fileType === 'excel') {
      await eventsExportService.exportToExcel(criteria, $translate.instant('export.audit-events'), 'event/latest/audit');
    } else if (fileType === 'csv') {
      await eventsExportService.exportToCsv(criteria, $translate.instant('export.audit-events'), 'event/latest/audit');
    }
    ctrl.fetching = false;
  };

  ctrl.scrollElementTop = element => {
    if (element) {
      $(element).animate({ scrollTop: 0 }, 'fast');
    }
  };

  ctrl.eventColor = event => {
    if (env.profile === 'VALE') {
      return event.qualifier ? event.qualifier : event.priority;
    } else {
      return event.priority;
    }
  };
}

angular
  .module('gridlets.module')
  .controller('AuditEventsController', AuditEventsController);